import utils from 'utils'
import popUpEmploye from '../../personalIncomeTax/parameterConfiguration/view/popUpEmploye.html'
class declareParamEditCtrl {
    constructor($scope, httpRequest, logger, $timeout, $uibModal, $state, $stateParams) {
        $scope.isActive = false
        $scope.isTaxActive = false
        $scope.hide = true //默认隐藏
        $scope.shortObjName = []
        // 申报配置信息 // 搬运
        $scope.loginInfoList = []
        //纳税人基本信息
        $scope.basicInfor = {
            companyName: '',
            taxNo: '',
            taxBelong: '',
            cityName: '',
            departmentNo: '',
            taxplayerType: '',
            regionName: '',
            accessToken: localStorage.getItem('id_token'),
            employeeName: '',
            employeeNumber: '',
        }
        // 增值税及附加纳税申报
        $scope.addTaxParam = {
            declareType: '1',
            reportingPeriod: '1',
            declarationTools: '1',
            whetherToCollectTax: '0',
            status: 0,
            rpaGroup: '',
        }
        // 印花税纳税申报
        $scope.stampDutyParam = {
            declareType: '2',
            reportingPeriod: '1',
            declarationTools: '1',
            whetherToCollectTax: '0',
            status: 0,
            rpaGroup: '',
        }
        // 企业所得税预缴纳税申报
        $scope.incomeTaxParam = {
            declareType: '3',
            reportingPeriod: '1',
            declarationTools: '1',
            whetherToCollectTax: '0',
            status: 0,
            rpaGroup: '',
            submissionStatus: '0',
            accountingStandard: '0',
        }
        // 字典
        const typecodeArrStr = ['zzs_declareType', 'zzs_reportingPeriod', 'zzs_declarationTools', 'zzs_whetherToCollectTax', 'zzs_status', 'zzs_loginPlatform', 'zzs_loginMode', 'zzs_userIdentity', 'accounting_standard', 'submission_status']
        $scope.dictionary = {}
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictionary, res.data.value)
            //增值税及附加纳税申报周期
            $scope.addDeclarationType = $scope.dictData.zzs_reportingPeriod
            //印花税纳税申报周期
            $scope.stampDeclarationType = $scope.dictData.zzs_reportingPeriod
        })
        // 查询所有纳税人
        $scope.getCompanyNames = function (val) {
            $scope.resetBasicInfor()
            let params = {
                companyName: val,
            }
            return httpRequest.get_getSbNo(params).then((res) => {
                $scope.loadingLocations = true
                return res.data.value
            })
        }
        //将下拉选的数据值赋值给文本框
        $scope.selectTaxName = function (item) {
            $scope.basicInfor.taxNo = item.taxNo
            $scope.basicInfor.taxBelong = item.taxBelong
            $scope.basicInfor.logonName = item.taxNo
            $scope.basicInfor.cityName = item.cityName
            $scope.basicInfor.departmentNo = item.departmentNo
            $scope.basicInfor.taxplayerType = item.taxplayerType
            $scope.basicInfor.regionName = item.regionName
        }
        // 重置纳税人
        $scope.resetBasicInfor = function () {
            $scope.basicInfor.taxNo = ''
            $scope.basicInfor.taxBelong = ''
            $scope.basicInfor.logonName = ''
            $scope.basicInfor.cityName = ''
            $scope.basicInfor.departmentNo = ''
            $scope.basicInfor.taxplayerType = ''
            $scope.basicInfor.regionName = ''
        }
        //纳税人主体类型判断可选申报周期
        $timeout(() => {
            $scope.$watch('basicInfor.taxplayerType', (newVal, oldVal) => {
                if (newVal == '一般纳税人') {
                    //增值税及附加纳税申报周期
                    $scope.addDeclarationType = $scope.dictData.zzs_reportingPeriod.filter((item) => {
                        return item.enumName == '按月申报'
                    })
                } else if (newVal == '小规模纳税人') {
                    //增值税及附加纳税申报周期
                    $scope.addDeclarationType = $scope.dictData.zzs_reportingPeriod.filter((item) => {
                        return item.enumName == '按季申报'
                    })
                }
                if (Array.isArray($scope.addDeclarationType)) {
                    $scope.addTaxParam.reportingPeriod = $scope.addDeclarationType[0].enumCode
                }
                //印花税纳税申报周期 企业所得税预缴纳税申报
                if (Array.isArray($scope.stampDeclarationType)) {
                    $scope.stampDeclarationType = $scope.stampDeclarationType.filter((item) => {
                        return item.enumName == '按季申报' || item.enumName == '按次申报' || item.enumName == '按月申报'
                    })
                }
            })
        }, 1000)

        // 编辑传过来的id
        const { id } = $stateParams
        if (id) {
            $scope.isEdit = true
            httpRequest.get_getCongByTaxNo(id).then((res) => {
                // console.log(res.data.value[0])
                $scope.editData = res.data.value[0]
                $scope.basicInfor.companyName = $scope.editData.companyName
                $scope.basicInfor.taxNo = $scope.editData.taxNo
                $scope.basicInfor.taxBelong = $scope.editData.taxBelong
                $scope.basicInfor.cityName = $scope.editData.cityName
                $scope.basicInfor.departmentNo = $scope.editData.departmentNo
                $scope.basicInfor.taxplayerType = $scope.editData.taxplayerType
                $scope.basicInfor.regionName = $scope.editData.regionName
                $scope.basicInfor.employeeName = $scope.editData.employeeName
                $scope.basicInfor.employeeNumber = $scope.editData.employeeNumber
                // 编辑 原始数据
                $scope.originalCompanyName = $scope.editData.companyName
                $scope.originalTaxNo = $scope.editData.taxNo
                angular.forEach($scope.editData.informationListDtoList, function (item, index) {
                    const declarationType = {
                        1: {
                            typeMapper() {
                                $scope.addTaxParam = item
                                $scope.addTaxParam.status = Number(item.status)
                            },
                        },
                        2: {
                            typeMapper() {
                                $scope.stampDutyParam = item
                                $scope.stampDutyParam.status = Number(item.status)
                            },
                        },
                        3: {
                            typeMapper() {
                                $scope.incomeTaxParam = item
                                $scope.incomeTaxParam.status = Number(item.status)
                                $scope.incomeTaxParam.submissionStatus = item.submissionStatus.toString()
                                $scope.incomeTaxParam.accountingStandard = item.accountingStandard.toString()
                            },
                        },
                    }
                    declarationType[item.declareType].typeMapper()
                })
                //处理有效状态
                angular.forEach($scope.editData.loginInformations, function (item, index) {
                    item.status = Number(item.status)
                })
                $scope.loginInfoList = $scope.editData.loginInformations
            })
        }
        $scope.addConfigurationInfor = function () {
            $uibModal
                .open({
                    templateUrl: 'addConfigInfo.html',
                    openedClass: 'mod-modal mod-modal-lg',
                    animation: true,
                    controller: [
                        '$scope',
                        '$uibModalInstance',
                        'logger',
                        'httpRequest',
                        'items',
                        function ($scope, $uibModalInstance, logger, httpRequest, items) {
                            $scope.dictData = items
                            $scope.loginInfo = {
                                loginPlatform: '1',
                                loginMode: '1',
                                loginAccount: '',
                                subAccount: '',
                                loginPassword: '',
                                userIdentity: '3',
                                taxOfficerName: '',
                                taxOfficerPhoneNumber: '',
                                taxOfficerPassword: '',
                                taxOfficerIdNumber: '',
                                registrationCode: '',
                                status: 1,
                            }
                            // 校验
                            $scope.checkloginInfo = function () {
                                console.log($scope.loginInfo)
                                if (!$scope.loginInfo.loginPlatform) {
                                    logger.logError('登录平台不允许为空')
                                    return false
                                }
                                if (!$scope.loginInfo.loginAccount) {
                                    logger.logError('登录用户名不允许为空')
                                    return false
                                }
                                if (!$scope.loginInfo.loginPassword) {
                                    logger.logError('登录用户密码不允许为空')
                                    return false
                                }
                                if (!$scope.loginInfo.taxOfficerName) {
                                    logger.logError('办税用户姓名不允许为空')
                                    return false
                                }
                                if (!utils.regExpTest($scope.loginInfo.taxOfficerPhoneNumber, 'mobile') && $scope.loginInfo.taxOfficerPhoneNumber != '') {
                                    logger.logError('提示：手机号码规则不符，请检查')
                                    return false
                                }
                                if (!utils.regExpTest($scope.loginInfo.taxOfficerIdNumber, 'IdNumber') && $scope.loginInfo.taxOfficerIdNumber != '') {
                                    logger.logError('身份证号长度仅允许15位或18位，请检查。')
                                    return false
                                }
                                return true
                            }
                            $scope.cancel = function cancel() {
                                $uibModalInstance.dismiss()
                            }
                            $scope.ok = function ok() {
                                if (!$scope.checkloginInfo()) {
                                    return
                                }
                                $uibModalInstance.close($scope.loginInfo)
                            }
                        },
                    ],
                    resolve: {
                        items() {
                            return $scope.dictData
                        },
                    },
                })
                .result.then((res) => {
                    $scope.loginInfoList.push(res)
                    console.log($scope.loginInfoList)
                })
        }
        // 取消
        $scope.cancel = function () {
            $state.go('declaration.vatDeclarationSurcharges.declareParam.list')
        }
        // 申报配置信息 修改
        $scope.handleAction = function (index, type) {
            $scope.PlatformEditIdx = index
            $scope.loginModeEditIdx = index
            $scope.userIdEditIdx = index
        }
        $scope.selectLoginInfo = function (dictData, type) {
            const loginInfoType = {
                loginPlatform: {
                    typeMapper() {
                        $scope.loginPlatformEnumCode = dictData.enumCode
                        $scope.loginInfoList[$scope.PlatformEditIdx].loginPlatform = String(dictData.enumCode)
                    },
                },
                loginMode: {
                    typeMapper() {
                        $scope.loginModeEnumCode = dictData.enumCode
                        $scope.loginInfoList[$scope.loginModeEditIdx].loginMode = String(dictData.enumCode)
                    },
                },
                userIdentity: {
                    typeMapper() {
                        $scope.userIdentityEnumCode = dictData.enumCode
                        $scope.loginInfoList[$scope.userIdEditIdx].userIdentity = String(dictData.enumCode)
                    },
                },
            }
            loginInfoType[type].typeMapper()
        }
        // 完成  12100  新增和编辑 的异常代码
        $scope.submit = function () {
            $scope.params = id
                ? {
                      companyName: $scope.basicInfor.companyName,
                      employeeName: $scope.basicInfor.employeeName,
                      employeeNumber: $scope.basicInfor.employeeNumber,
                      taxId: id,
                      informationEditDtoList: [$scope.addTaxParam, $scope.stampDutyParam, $scope.incomeTaxParam],
                      loginInformationEditDtos: $scope.loginInfoList,
                      taxNo: $scope.basicInfor.taxNo,
                  }
                : {
                      companyName: $scope.basicInfor.companyName,
                      employeeName: $scope.basicInfor.employeeName,
                      employeeNumber: $scope.basicInfor.employeeNumber,
                      informationListDtoList: [$scope.addTaxParam, $scope.stampDutyParam, $scope.incomeTaxParam],
                      loginInformationListDtoList: $scope.loginInfoList,
                      taxNo: $scope.basicInfor.taxNo,
                  }
            // 编辑时变更纳税人名称
            if (id) {
                let originalCompanyName = $scope.originalCompanyName.replaceAll('（', '(').replaceAll('）', ')')
                let companyName = $scope.params.companyName.replaceAll('（', '(').replaceAll('）', ')')
                $scope.originalTaxNo == $scope.params.taxNo ? ($scope.params.oneself = '1') : ($scope.params.oneself = '0')
            }
            // 校验
            if (!$scope.checkParamsInfo($scope.params)) {
                return
            }
            id
                ? httpRequest.post_sbConfigEdit(JSON.stringify($scope.params), '编辑成功').then((res) => {
                      $state.go('declaration.vatDeclarationSurcharges.declareParam.list')
                  })
                : httpRequest.post_sbConfigInsert(JSON.stringify($scope.params), '新增成功').then((res) => {
                      $state.go('declaration.vatDeclarationSurcharges.declareParam.list')
                  })
        }
        // 校验
        // (^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)
        $scope.checkParamsInfo = function (data) {
            if (data.companyName == '') {
                logger.logError('纳税人名称不允许为空')
                return false
            }
            if (data.taxNo == '') {
                logger.logError('纳税人识别号不允许为空')
                return false
            }
            try {
                angular.forEach(id ? data.informationEditDtoList : data.informationListDtoList, function (item, index) {
                    if (item.rpaGroup == '') {
                        logger.logError(`请输入第${index + 1}行机器人分组`)
                        throw new Error(true)
                    }
                    if (!isRuledNumber(item.rpaGroup)) {
                        logger.logError(`机器人分组第${index + 1}行仅允许输入正整数`)
                        throw new Error(true)
                    }
                })
                // 必填校验
                angular.forEach(id ? data.loginInformationEditDtos : data.loginInformationListDtoList, function (item, index) {
                    if (item.loginAccount == '' || item.loginPassword == '' || item.taxOfficerName == '') {
                        logger.logError(`第${index + 1}行${item.loginAccount ? (item.loginPassword ? '办税用户姓名' : '登录密码') : '登录账户名'}不允许为空`)
                        throw new Error(true)
                    }
                })
            } catch (e) {
                if (e) {
                    return false
                }
            }
            let addListLen = id ? data.loginInformationEditDtos.length : data.loginInformationListDtoList.length
            if (addListLen <= 0) {
                logger.logError('申报登录信息至少需要录入1条信息才允许保存')
                return false
            }
            return true
        }
        //只能非0正整数
        function isRuledNumber(argument) {
            // const reg = /^\+?(0|[1-9][0-9]*)$/
            const reg = /^\+?[1-9][0-9]*$/
            return reg.test(argument)
        }
        // 获取所有用户信息
        $scope.params = {
            pageSize: 2000,
            pageNum: 1,
            param: {
                isRoleOwner: '1', // 拥有本机构角色
                orgIdList: [JSON.parse(localStorage.user_info).org.orgId], // 所属机构
            },
        }
        httpRequest.post_usersInfo($scope.params).then((res) => {
            $scope.allUserInfo = res.data.value.list
        })
        $scope.selectFollower = function () {
            $uibModal
                .open({
                    template: popUpEmploye,
                    controller: 'popUpEmployeCtrl',
                    backdrop: 'static',
                    openedClass: 'mod-modal-modaldetails mod-modal mod-modal-hg',
                    resolve: {
                        modalParams() {
                            return {
                                info: $scope.allUserInfo,
                                type: 'changeFollower',
                            }
                        },
                    },
                })
                .result.then((res) => {
                    const { userName, realName, updateUser, updateTime } = res[0]
                    $scope.basicInfor.employeeName = realName
                    $scope.basicInfor.employeeNumber = userName
                })
        }
    }
}

declareParamEditCtrl.$inject = ['$scope', 'httpRequest', 'logger', '$timeout', '$uibModal', '$state', '$stateParams']
export default declareParamEditCtrl



// WEBPACK FOOTER //
// ./src/app/declaration/vatDeclarationSurcharges/declareParam/declareParamEditCtrl.js